import { Link } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

export const NavLink = ({
  path,
  children,
  ...rest
}: {
  path: string;
  children: React.ReactNode;
} & React.HTMLAttributes<HTMLAnchorElement>) => (
  <Link
    {...rest}
    component={RouterLink}
    to={path}
    underline="none"
    sx={{ width: 1 }}
  >
    {children}
  </Link>
);
